import { applySnapshot, types } from 'mobx-state-tree';

const App = types
  .model({
    toastOpen: false,
    toastTitle: '',
    toastMessage: '',
    toastType: types.union(types.literal('success'), types.literal('error')),
    toastDuration: 6000,
  })
  .actions((self) => ({
    updateField: (field: string, value: string | number | boolean) => {
      applySnapshot(self, { ...self, [field]: value });
    },
  }))
  .actions((self) => ({
    closeToast: () => {
      self.toastOpen = false;
      setTimeout(() => {
        self.updateField('toastTitle', '');
        self.updateField('toastMessage', '');
      }, 300);
    },
  }))
  .actions((self) => ({
    openToast: ({
      type = 'success',
      title,
      message,
      toastDuration = 6000,
    }: {
      type?: 'success' | 'error';
      title: string;
      message: string;
      toastDuration?: number;
    }) => {
      self.toastType = type;
      self.toastOpen = true;
      self.toastTitle = title;
      self.toastMessage = message;
      self.toastDuration = toastDuration;
      setTimeout(() => {
        self.closeToast();
      }, toastDuration);
    },
  }));
export default App;
